
import React, { Component } from 'react';
class Msis extends Component {



  render() {
    return (

      <section className="services-section-four">

        <div className='auto-container'>
          <div className='row'>

            <div className='col-md-12'>




              <div className="text-center m-b-20 m-t-20">

                <div className="text-center">
                  <h2 className='ct-heading-tag'>MSIS</h2>
                </div>

                <img src='../assets/images/msisLogo.png' className="rounded-circle img-thumbnail" alt="MSIS LOGO" />


                <div className=" m-b-20 m-t-20">
                  <p className="text-2">MUNICIPAL SOFTWARE INFORMATIC SOLUTIONS</p>
                  <p className="text-2" >منظومات و حلول إعلاميّة للبلديّات</p>


                  <div className="contact-widget" >
                    <p>(+216) 99 048 080 </p>
                    <p>msis.bmm@gmail.com </p>
                  </div>

                </div>



              </div>


            </div>

          </div>



        </div>



      </section>
    )
  }
}


export default Msis  